/** Der feste Bereich (Gesundheit, Schule, Finanzen); `undefined` = lädt noch, `null` = gibt es nicht. */
import { useLiveQuery } from 'dexie-react-hooks';

import { db } from '@/db/schema';
import type { Area, FesterBereich } from '@/domain/types';

export function useFesterBereich(fest: FesterBereich): Area | null | undefined {
  return useLiveQuery(async () => (await db.areas.toArray()).find((a) => a.fest === fest) ?? null, [fest], undefined) as Area | null | undefined;
}
